import styled from 'styled-components/macro'
import { transparentize } from 'polished'

import { Button } from 'components/ui'

export const GenerateConainer = styled.div<{ isShow: boolean }>`
  padding: 0;
  width: 100%;
  display: ${(props) => (props.isShow ? 'flex' : 'none')};
  flex-direction: column;
  background-color: ${(props) => transparentize(0.96, props.theme.color.text)};
  border: 0.1rem solid ${(props) => props.theme.color.inputColor};
  border-radius: 0.8rem;
  overflow: hidden;
`

export const GenerateTitle = styled.h5`
  margin: 0;
  padding: 1rem 1.6rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.6rem;
  line-height: 1.33;
  text-align: left;
  border-bottom: 0.1rem solid ${(props) => props.theme.color.inputColor};
  cursor: help;
`

export const GenerateWrapper = styled.div`
  padding: 1rem 1.6rem 1.6rem 1.6rem;
  display: grid;
  grid-template-columns: 1fr;
  align-items: flex-end;
  gap: 0.8rem;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    grid-template-columns: repeat(2, 1fr) 0.5fr;
    gap: 1.2rem;
  `};
`

export const StyledButton = styled(Button)`
  height: 4.6rem;
`

export const Info = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 2.6rem;
  height: 2.6rem;
  background-color: ${(props) => props.theme.color.buttonBgThird};
`
